<template>
  <v-layout row justify-center>
        <v-container>
          <v-stepper v-model="step">
            <v-stepper-header>
              <v-stepper-step :complete="step > 1" :editable="setSteps == 1" step="1" v-if="setSteps >= 1">Ano Letivo
                <span v-if="choices.aaletivo">
                  {{choices.aaletivo.aaletivo}}
                </span>
              </v-stepper-step>

              <v-divider></v-divider>

              <v-stepper-step :complete="step > 2" :editable="(setSteps == 2 && step > setSteps)" step="2" v-if="setSteps >= 2">Nível de Ensino
                <span v-if="choices.cdinstruc">
                  {{choices.cdinstruc.nivel.dsinstruc}}
                </span>
              </v-stepper-step>

              <v-divider v-if="setSteps >= 3"></v-divider>

              <v-stepper-step :complete="step > 3" :editable="step > 3" step="3" v-if="setSteps >= 3">Etapa Escolar
                <span v-if="choices.cdserie">
                  {{choices.cdserie.dsserie}}
                </span>
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-radio-group v-if="anoletivo.length" v-model="choices.aaletivo">
                  <v-radio
                    color="#25848C"
                    :ripple="false"
                    v-for="aaletivo in anoletivo"
                    :key="key(aaletivo)"
                    :label="aaletivo.aaletivo.toString()"
                    :value="aaletivo"
                  />
                </v-radio-group>
                <p v-if="!anoletivo.length">
                  Nenhuma ano letivo encontrado
                </p>

                <v-btn
                  v-if="setSteps!==1"
                  :disabled="!choices.aaletivo || loading"
                  color="primary"
                  @click="getNivel()"
                  :loading="loading"
                  class="me-2 rounded-sm font-weight-regular"
                >Continuar</v-btn>
                <v-btn class="rounded-sm font-weight-regular" v-if="setSteps===1" color="success" :disabled="!choices.aaletivo" @click="confirm">Confirmar</v-btn>
              </v-stepper-content>
<!-- segundo -->
              <v-stepper-content step="2">
                <v-radio-group v-if="niveis.length" v-model="choices.cdinstruc">
                  <v-radio
                    color="#25848C"
                    :ripple="false"
                    v-for="nivel in niveis"
                    :key="key(nivel)"
                    :label="`${nivel.nivel.cdinstruc} - ${nivel.nivel.dsinstruc}`"
                    :value="nivel"
                  />
                </v-radio-group>

                <p v-if="!niveis.length">
                  Nenhum nível de ensino encontrado
                </p>

                <v-btn
                  v-if="setSteps!==2"
                  :disabled="!choices.cdinstruc || loading"
                  color="primary"
                  @click="getEtapa()"
                  :loading="loading"
                  class="me-2 rounded-sm font-weight-regular"
                >Continuar</v-btn>
                <v-btn  v-if="setSteps===2" class="me-2 rounded-sm font-weight-regular" color="success" :disabled="!choices.cdinstruc" @click="confirm">Confirmar</v-btn>
                <v-btn class="rounded-sm font-weight-regular" @click="back('cdinstruc')">Voltar</v-btn>
              </v-stepper-content>
              <v-stepper-content step="3">
                <v-radio-group v-if="etapas.length" v-model="choices.cdserie">
                  <v-radio color="#25848C" :ripple="false" :value="{cdserie:0,dsserie:'Todos'}" :key="key({cdinstruc:0,dsserie:'Todos'})" >
                    <span slot="label">Todos</span>
                  </v-radio>
                  <v-radio
                    color="#25848C"
                    :ripple="false"
                    v-for="cdserie in etapas"
                    :key="key(cdserie)"
                    :value="cdserie"
                  >
                    <span slot="label">
                      {{cdserie.dsserie}}
                    </span>
                  </v-radio>
                </v-radio-group>

                <p v-if="!etapas.length">
                  Nenhuma etapa escolar encontrada
                </p>
                <v-btn class="me-2 rounded-sm font-weight-regular" v-if="setSteps===3" color="success" :disabled="!choices.cdserie" @click="confirm">Confirmar</v-btn>
                <v-btn class="rounded-sm font-weight-regular"  @click="back('cdserie')">Voltar</v-btn>
              </v-stepper-content>

            </v-stepper-items>
          </v-stepper>
        </v-container>
  </v-layout>
</template>

<script>
import api from '@/api';
import _ from 'lodash';

const defaultstate = () => ({
  options: {
    aaletivo: [],
    cdinstruc: [],
    cdserie: [],
  },
  choices: {
    aaletivo: null,
    cdinstruc: null,
    cdserie: null,
  },
  step: 1,
  loading: false,
});

export default {
  name: 'busca-ano-nivel-etapa',
  props: {
    setSteps: {
      type: Number,
      default: 3,
    },
  },
  async created() {
    this.getAno();
  },
  data() {
    return defaultstate();
  },
  methods: {
    confirm() {
      this.$emit('chosen', this.choices);
      this.step = 4;
    },
    back(choice) {
      this.step--;
      this.choices[choice] = null;
    },
    async get(resource) {
      const { data } = await api.get(`ei/${resource}`);
      return data.results;
    },
    async getAno() {
      this.loading = true;
      this.options.aaletivo = await this.get('grade/anosletivos?take=5');
      this.loading = false;
    },
    async getNivel(){
      this.loading = true;
      let anoescolhido = this.choices.aaletivo.aaletivo;
      this.options.cdinstruc = await this.get(`grade/nivelensino?aaletivo=${anoescolhido}`);
      this.step = 2;
      this.loading = false;
    },
    async getEtapa(){
      this.loading = true;
      let nivelescolar = this.choices.cdinstruc.cdinstruc;
      this.options.cdserie = await this.get(`distribuirnotas/etapaescolar?cdinstruc=${nivelescolar}`);
      this.step = 3;
      this.loading = false;
    },
    key(k){
      return JSON.stringify(k);
    }
  },
  computed: {
    anoletivo() {
      return this.options.aaletivo;
    },
    niveis() {
      return _.orderBy(this.options.cdinstruc,'nivel.dsinstruc','asc');
    },
    etapas() {
      return _.orderBy(this.options.cdserie,'dsserie','asc');
    },
  },
};
</script>

<style>
</style>
